import { render, staticRenderFns } from "./DeliveryInStockDetail.vue?vue&type=template&id=4b44ce02&scoped=true"
import script from "./DeliveryInStockDetail.vue?vue&type=script&lang=js"
export * from "./DeliveryInStockDetail.vue?vue&type=script&lang=js"
import style0 from "./DeliveryInStockDetail.vue?vue&type=style&index=0&id=4b44ce02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b44ce02",
  null
  
)

export default component.exports